export const accountHolderDetailsEn = {};

export const accountHolderDetailsFr = {};
